export const resolveBrandLogo = (storedLogo, defaultLogo) => {
  if (
    !storedLogo ||
    storedLogo === 'null' ||
    storedLogo === 'undefined'
  ) {
    return defaultLogo;
  }

  return storedLogo;
};
